import React, { FunctionComponent } from 'react';
import { Input } from '../../atoms/input';
import { Button } from '../../atoms/button';
import { FlashBox } from '../../atoms/flashBox';
import { DataCategory, DataValueRecruitmentShowContent, DataValueRecruitmentShowContentBrand, Occupation, PreferredOccupation, Prefecture, OccupationDetail, GraduationEntry, DataValueRecruitmentRegisterModal } from '../../../types/recruitmentShow';
import { Follow } from '../../molecules/follow';
import { RecruitmentShowContentFollowSlider } from '../../molecules/recruitmentShowContentFollowSlider';
import { BrandOther } from '../../organisms/brandOther';
import { RecruitmentRegisterModal } from '../../organisms/recruitmentRegisterModal';
import { LoginModal } from '../../organisms/loginModal';

type Props = {
  recruitmentId?: number;
  companyId: number;
  adminBrandId?: number;
  isStopped?: boolean;
  isUser?: boolean;
  user?: 'company' | 'person' | 'without_login';
  noimage: string;
  occupationName?: string;
  occupationUrl?: string;
  industryUrl?: string;
  isCompany?: boolean;
  dataCategory?: string | DataCategory;
  dataValue?: DataValueRecruitmentShowContent | DataValueRecruitmentShowContentBrand;
  isDisplayed?: boolean;
  isShow?: boolean;
  hoverIcon?: string;
  cancelIcon?: string;
  brandId?: number;
  instagramIcon?: string;
  isPc?: boolean;
  isSp?: boolean;
  isBrandPage?: boolean;
  isCompanyPage?: boolean;
  isStoppedFv?: boolean;
  lineIcon: string;
  isPreview?: boolean;
  // RecruitmentRegisterModal用の追加props
  occupations?: Occupation[];
  preferredOccupations?: PreferredOccupation[];
  occupationDetails?: OccupationDetail[];
  graduationArray?: GraduationEntry[];
  graduationAnnotaion?: number;
  prefectures?: Prefecture[];
  redirectUrl?: string;
  dataCategoryRegisterModal?: string;
  dataValueRegisterModal?: DataValueRecruitmentRegisterModal;
  handleRegisterModalOpen?: () => void;
  handleSwitchLoginModalOpen?: () => void;
  handleConnectModalOpen?: () => void;
  handleIsLogin?: () => void;
  handleFlash?: (flash: boolean, flashType: string, flashMessage: string) => void;
  // FlashBox用の追加props
  flash?: boolean;
  flashType?: string;
  flashMessage?: string;
  // LoginModal用の追加props
  isLoginModalOpen: boolean;
  isRegisterModalOpen: boolean;
  isLoginError?: boolean;
  modalFlashMessage?: string;
  handleToggleLoginModal?: () => void;
  handleChangeModal?: (from: "login" | "register") => void;
  // Connect Modal用の追加props
  isConnectModalOpen?: boolean;
  isConnectCompleteModalOpen?: boolean;
  interest?: 'want_to_work' | 'want_to_hear' | 'interesting';
  isScouted?: boolean;
  isStudentAndMidCareer?: boolean;
  isSubmitting?: boolean;
  hasRequiredProfiles?: boolean;
  needProfileUpdate?: boolean;
  requiredProfileNames?: string[];
  relatedRecruitments?: any[];
  companyName?: string;
  userId?: number;
  handleClickModalBg?: () => void;
  handleSubmitConnect?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleChangeInterest?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  // 通知メール受け取り用の追加Props
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  isLoading: boolean;
  isSubmitted: boolean;
  handleEmailSubmit: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  recruitmentId,
  companyId,
  adminBrandId,
  isStopped,
  user,
  noimage,
  occupationName,
  occupationUrl,
  industryUrl,
  isCompany,
  dataCategory,
  dataValue,
  isDisplayed,
  hoverIcon,
  brandId,
  instagramIcon,
  isPc,
  isSp,
  isBrandPage,
  isCompanyPage,
  isStoppedFv,
  lineIcon,
  isPreview,
  occupations = [],
  preferredOccupations = [],
  occupationDetails = [],
  graduationArray = [],
  graduationAnnotaion = 0,
  prefectures = [],
  redirectUrl = '',
  // RecruitmentRegisterModal用の追加props
  dataCategoryRegisterModal = '',
  dataValueRegisterModal = {} as DataValueRecruitmentRegisterModal,
  handleRegisterModalOpen,
  handleSwitchLoginModalOpen,
  handleConnectModalOpen,
  handleIsLogin,
  handleFlash,
  // FlashBox用の追加props
  flash,
  flashType,
  flashMessage,
  // LoginModal用の追加props
  isLoginModalOpen,
  isRegisterModalOpen,
  isLoginError,
  modalFlashMessage,
  handleToggleLoginModal,
  handleChangeModal,
  // 通知メール受け取り用の追加Props
  email,
  setEmail,
  isLoading,
  isSubmitted,
  handleEmailSubmit,
}) => {
  const handleCloseModal = () => {
    $('html, body').removeAttr('style');
  };

  const isEmailSubmitDisabled = isLoading || isSubmitted;
  const emailSubmitButtonText = isLoading ? '送信中...' : (isSubmitted ? '登録完了' : '通知を受け取る');
  const contentClassName = [
    'recruitment__show__content',
    isDisplayed && 'is-displayed',
    isCompanyPage && 'wide',
    isBrandPage && 'narrow',
    // isStoppedFv && isStopped && 'is-stopped',
    isStopped && 'is-stopped',
    isSp && 'is-view'
  ].filter(Boolean).join(' ');
  const followWrapperClassName = [
    'recruitment__show__wrapper__follow',
    isCompany && 'is-hide',
    isDisplayed && 'is-displayed'
  ].filter(Boolean).join(' ');
  const followContentClassName = [
    'recruitment__show__wrapper__follow__content',
    isBrandPage && 'is-brand-page'
  ].filter(Boolean).join(' ');
  const shouldShowStoppedCompanyMessage = isDisplayed && !isBrandPage;
  const shouldShowStoppedBrandEmailMessage =
    (isDisplayed && !isBrandPage) || (user === 'without_login' && isDisplayed && isBrandPage);
  const shouldShowStoppedBrandCompanyMessage = user === 'company' && isDisplayed && isBrandPage;
  const shouldShowStoppedBrandPersonMessage = user === 'person' && isDisplayed && isBrandPage;
  const shouldShowRestartNotificationMessage = !isDisplayed && !isBrandPage;
  const shouldShowRecruitmentSlider = !isDisplayed && !isBrandPage && recruitmentId && typeof isStopped === 'boolean' && dataCategory && dataValue;

  const renderEmailNotificationForm = () => (
    <div className="recruitment__show__follow__form">
      <Input
        name='email'
        type="text"
        className="recruitment__show__follow__form--input"
        placeholder="メールアドレスを入力してください"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <Button
        className={`recruitment__show__follow__form--button ${isEmailSubmitDisabled ? 'disabled' : ''} gtm-button-view-count`}
        onClicked={(e) => {
          if (isEmailSubmitDisabled) {
            e.preventDefault();
            return;
          }
          handleEmailSubmit();
        }}
        defaultValue={emailSubmitButtonText}
      />
    </div>
  );

  const renderFollowMessage = (
    className: string,
    title: string,
    description: React.ReactNode,
    children?: React.ReactNode
  ) => (
    <div className={className}>
      <h2 className="recruitment__show__follow__title">{title}</h2>
      <p className="recruitment__show__follow__description">{description}</p>
      {children}
    </div>
  );

  return (
    <div className={contentClassName}>
      <FlashBox
        flash={flash || false}
        flashType={flashType || ''}
        flashMessage={flashMessage || ''}
        handleFlash={handleFlash || (() => {})}
      />
      <div className={followWrapperClassName}>
        <div className={followContentClassName} id='company_id_stopped' data-company_id={companyId}>
          {isStoppedFv ? (
            <>
              {shouldShowStoppedCompanyMessage && renderFollowMessage(
                'recruitment__show__content__follow__sentense',
                'この会社は募集を終了しています',
                <>
                  現在、この会社は募集を終了しています。<br />
                  会社をフォローしておくと募集再開の際に<br />
                  メールにてお知らせが届きます。
                </>
              )}
              {shouldShowStoppedBrandEmailMessage && renderFollowMessage(
                'recruitment__show__content__follow__sentense',
                '現在、このブランドは募集を終了しています',
                <>気になるブランドの募集が再開したら、すぐにお知らせします。</>,
                renderEmailNotificationForm()
              )}
              {shouldShowStoppedBrandCompanyMessage && renderFollowMessage(
                'recruitment__show__content__follow__sentense',
                'このブランドは募集を終了しています',
                <>現在、このブランドは募集を終了しています。</>
              )}
              {shouldShowStoppedBrandPersonMessage && renderFollowMessage(
                'recruitment__show__content__follow__sentense',
                'このブランドは募集を終了しています',
                <>
                  現在、このブランドは募集を終了しています。<br />
                  会社をフォローしておくと募集再開の際に<br />
                  メールにてお知らせが届きます。
                </>
              )}
              {shouldShowRestartNotificationMessage && renderFollowMessage(
                'recruitment__show__wrapper__follow__content__sentense',
                'この求人は募集を終了しています',
                <>
                  メールアドレスを登録しておくと<br />
                  募集が再開したら、すぐにお知らせします。
                </>,
                renderEmailNotificationForm()
              )}
            </>
          ) : (
            <>
              {shouldShowStoppedCompanyMessage && renderFollowMessage(
                'recruitment__show__content__follow__sentense',
                'この会社は募集を終了しています',
                <>
                  現在、この会社は募集を終了しています。<br />
                  会社をフォローしておくと募集再開の際に<br />
                  メールにてお知らせが届きます。
                </>
              )}
              {user === 'without_login' && isDisplayed && isBrandPage && renderFollowMessage(
                'recruitment__show__content__follow__sentense',
                '現在、このブランドは募集を終了しています',
                <>気になるブランドの募集が再開したら、すぐにお知らせします。</>,
                renderEmailNotificationForm()
              )}
              {shouldShowStoppedBrandCompanyMessage && renderFollowMessage(
                'recruitment__show__content__follow__sentense',
                'このブランドは募集を終了しています',
                <>現在、このブランドは募集を終了しています。</>
              )}
              {shouldShowStoppedBrandPersonMessage && renderFollowMessage(
                'recruitment__show__content__follow__sentense',
                'このブランドは募集を終了しています',
                <>
                  現在、このブランドは募集を終了しています。<br />
                  会社をフォローしておくと募集再開の際に<br />
                  メールにてお知らせが届きます。
                </>
              )}
              {shouldShowRestartNotificationMessage && renderFollowMessage(
                'recruitment__show__wrapper__follow__content__sentense',
                'この求人は募集を終了しています',
                <>
                  現在、この求人は募集を終了しています。<br />
                  会社をフォローしておくと募集再開の際に<br />
                  メールにてお知らせが届きます。
                </>
              )}
              {(user === 'person' || !isBrandPage) &&
                <Follow
                  company_id={String(companyId)}
                  user={user}
                  className='recruitment__show__follow__stopped'
                  page='stopRecruitment'
                  lineIcon={lineIcon}
                />
              }
            </>
          )}
        </div>
        {shouldShowRecruitmentSlider &&
          <RecruitmentShowContentFollowSlider
            noimage={noimage}
            companyId={companyId}
            recruitmentId={recruitmentId}
            isStopped={isStopped}
            occupationUrl={occupationUrl}
            occupationName={occupationName}
            industryUrl={industryUrl}
            target='recruitments'
            dataCategory={dataCategory as DataCategory}
            dataValue={dataValue as DataValueRecruitmentShowContent}
            isPreview={isPreview || false}
          />
        }
        {isBrandPage &&
          <BrandOther
            brandId={brandId as number}
            instagramIcon={instagramIcon}
            noimage={noimage}
            hoverIcon={hoverIcon}
            isPc={isPc}
            dataCategory={dataCategory as any}
            dataValue={dataValue}
          />
        }
      </div>
      {/* RecruitmentRegisterModal */}
      <RecruitmentRegisterModal
        companyId={companyId}
        recruitmentId={recruitmentId}
        occupations={occupations}
        preferredOccupations={preferredOccupations}
        occupationDetails={occupationDetails}
        prefectures={prefectures}
        handleRegisterModalOpen={handleRegisterModalOpen || handleCloseModal}
        handleSwitchLoginModalOpen={handleSwitchLoginModalOpen || (() => { })}
        handleConnectModalOpen={handleConnectModalOpen || (() => { })}
        handleIsLogin={handleIsLogin || (() => { })}
        graduationArray={graduationArray}
        graduationAnnotaion={graduationAnnotaion}
        isRegisterOpenModal={isRegisterModalOpen || false}
        redirectUrl={redirectUrl}
        handleFlash={handleFlash || (() => { })}
        lineIcon={lineIcon}
        dataCategory={dataCategoryRegisterModal || ''}
        dataValue={dataValueRegisterModal}
        isBrandPage={isBrandPage}
        isStoppedFv={isStoppedFv}
      />

      {/* LoginModal */}
      <LoginModal
        isModalOpen={isLoginModalOpen}
        redirectUrl={redirectUrl || ''}
        fromButton="recruitment"
        recruitmentId={recruitmentId}
        isLoginError={isLoginError}
        flashMessage={modalFlashMessage}
        handleToggleLoginModal={handleToggleLoginModal || (() => { })}
        handleChangeModal={handleChangeModal || (() => { })}
        lineIcon={lineIcon}
      />
    </div>
  );
};
